__webpack_require__.p = "//cdn.cheweijia.com/qs/admin/vehicle-system/public/vehicle/260930_0910153304/";